import { redirect } from 'next/navigation';

export default function RolesOverviewPage() {
  // Redirect to system roles page as the overview page is no longer needed.
  redirect('/organization/roles/system-roles');
}

